// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._D5UsV9yaDe31fIAkANs {
  display: flex;
  flex-direction: column;
  gap: var(--sl-space-4);
  width: 100%;
  flex: 0 0 auto;
}

._D5UsV9yaDe31fIAkANs > * {
  flex-shrink: 0;
  min-width: 0;
}

._D5UsV9yaDe31fIAkANs > [data-component='HeaderWalletBalance'] {
  margin-top: 0;
  margin-bottom: 0;
}

/* The page Container is height: 100% of the viewport; keep this screen
   hugging its content so empty activity does not inherit a second viewport. */
section.content:has([data-wallet-detail]) {
  height: auto;
}

._D5UsV9yaDe31fIAkANs .empty-page {
  height: auto;
  min-height: 0;
  justify-content: flex-start;
  padding: var(--sl-space-8) 0;
}

/*
  The datepicker keeps the 2-month calendar in the DOM with visibility:hidden.
  That still extends document overflow below the activity section (movimentations).
  Clip it from the positioned wrapper instead of using display:none — react-dates
  measures the month caption height only once, on mount, and an unrendered
  calendar measures 0, leaving the day grid short and cut off when opened.
*/
._D5UsV9yaDe31fIAkANs .datepicker__wrapper:not(.--visible) {
  overflow: hidden;
}

/* Closed Shoreline Filter menus stay mounted; don't let them extend page scroll. */
._D5UsV9yaDe31fIAkANs [data-sl-popover][hidden] {
  display: none !important;
}

._D5UsV9yaDe31fIAkANs [data-sl-filter] > div:has(> [data-sl-popover][hidden]) {
  display: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/modules/retailMedia/components/WalletDetailSections/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;8EAC8E;AAC9E;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;;;;;;CAMC;AACD;EACE,gBAAgB;AAClB;;AAEA,mFAAmF;AACnF;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".stack {\n  display: flex;\n  flex-direction: column;\n  gap: var(--sl-space-4);\n  width: 100%;\n  flex: 0 0 auto;\n}\n\n.stack > * {\n  flex-shrink: 0;\n  min-width: 0;\n}\n\n.stack > [data-component='HeaderWalletBalance'] {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n/* The page Container is height: 100% of the viewport; keep this screen\n   hugging its content so empty activity does not inherit a second viewport. */\n:global(section.content):has([data-wallet-detail]) {\n  height: auto;\n}\n\n.stack :global(.empty-page) {\n  height: auto;\n  min-height: 0;\n  justify-content: flex-start;\n  padding: var(--sl-space-8) 0;\n}\n\n/*\n  The datepicker keeps the 2-month calendar in the DOM with visibility:hidden.\n  That still extends document overflow below the activity section (movimentations).\n  Clip it from the positioned wrapper instead of using display:none — react-dates\n  measures the month caption height only once, on mount, and an unrendered\n  calendar measures 0, leaving the day grid short and cut off when opened.\n*/\n.stack :global(.datepicker__wrapper:not(.--visible)) {\n  overflow: hidden;\n}\n\n/* Closed Shoreline Filter menus stay mounted; don't let them extend page scroll. */\n.stack :global([data-sl-popover][hidden]) {\n  display: none !important;\n}\n\n.stack :global([data-sl-filter] > div:has(> [data-sl-popover][hidden])) {\n  display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stack": `_D5UsV9yaDe31fIAkANs`
};
export default ___CSS_LOADER_EXPORT___;
